// ═══════════════════════════════════════════════════════════════════════════════
// Pairing-scoped GCS images — opaque API paths (no bucket URL in browser Network)
// ═══════════════════════════════════════════════════════════════════════════════
/** Safe object file names under pairing prefixes, e.g. `3e6e88d0-abba-4f9c-9342-d88226954d9e.webp` */
export const PAIRING_SCOPED_IMAGE_FILE_NAME_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\.(webp|jpe?g|png|heic|heif|bin)$/i;
export const isGcsCanonicalHttpsUrl = (src) => {
    const trimmed = src.trim();
    if (trimmed === '')
        return false;
    return (trimmed.startsWith('https://storage.googleapis.com/') ||
        /^https:\/\/[^/]+\.storage\.googleapis\.com\//.test(trimmed));
};
/** Last path segment of a canonical GCS HTTPS URL, or the input when already a bare file name. */
export const extractPairingScopedImageFileName = (src) => {
    const trimmed = src.trim();
    if (trimmed === '')
        return null;
    if (PAIRING_SCOPED_IMAGE_FILE_NAME_REGEX.test(trimmed)) {
        return trimmed;
    }
    if (!isGcsCanonicalHttpsUrl(trimmed)) {
        return null;
    }
    const pathStart = trimmed.indexOf('/', 'https://'.length);
    if (pathStart === -1)
        return null;
    const pathOnly = trimmed.slice(pathStart).split(/[?#]/)[0] ?? '';
    const segment = pathOnly.split('/').filter(Boolean).pop() ?? '';
    if (segment === '' || !PAIRING_SCOPED_IMAGE_FILE_NAME_REGEX.test(segment)) {
        return null;
    }
    return segment;
};
/** Authed stream path that hides bucket and object prefix from DevTools. */
export const buildPairingScopedImageApiPath = (canonicalUrlOrFileName) => {
    const fileName = extractPairingScopedImageFileName(canonicalUrlOrFileName);
    if (!fileName)
        return null;
    return `/api/files/pairing-scoped-images/${encodeURIComponent(fileName)}`;
};
export const isPairingScopedImageApiPath = (src) => {
    const trimmed = src.trim();
    return trimmed.startsWith('/api/files/pairing-scoped-images/');
};
//# sourceMappingURL=pairingScopedImage.js.map